<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                :placeholder="$t('search')"
                v-model="search"
                hide-details

              ></v-text-field>
              <v-btn
                v-if="can('create', 'user')"
                color="primary"
                @click="sendEmit('create')"
                small
              >{{$t('new')}}</v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="formatList"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                class="elevation-1"
                item-key="_id"
                :pagination.sync="pagination"
                :expand="expand"
                :loading="loading"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-center px-0">
                    <v-btn
                      v-if="can('edit', 'user', props.item)"
                      flat
                      small
                      icon
                      color="success"
                      class="mx-0"
                    >
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('update', props.item._id)"
                      >create</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="can('delete', 'user', props.item)"
                      flat
                      small
                      icon
                      color="error"
                      class="mx-0"
                    >
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('remove', props.item._id)"
                      >delete</v-icon>
                    </v-btn>
                  </td>
                  <td class="text-xs-center">
                    <i
                      class="success--text icon material-icons"
                      v-if="props.item.active"
                    >check_circle</i>
                    <i class="error--text icon material-icons" v-else>cancel</i>
                  </td>
                  <td v-if="isAdmin" class="text-xs-center">
                    <i
                      class="success--text icon material-icons"
                      v-if="props.item.deleted"
                    >check_circle</i>
                    <i class="error--text icon material-icons" v-else>cancel</i>
                  </td>
                  <td class="text-xs-center">
                    <v-avatar size="32">
                      <!-- <img :src="urlBase" alt=""> -->
                      <img :src="image(props.item)" alt>
                    </v-avatar>
                  </td>
                  <td>{{ props.item.name }} {{props.item.lastname1}}</td>
                  <td>{{ props.item.entities }}</td>
                  <td>{{props.item.province}}</td>
                  <td>{{ props.item.email }}</td>
                  <!--<td>
                                       {{props.item.rolespermissions}}
                  </td>-->
                  <td @click="props.expanded = !props.expanded" class="cursor text-xs-center">
                    <i class="icon material-icons">visibility</i>
                  </td>
                  <td>{{props.item.createdAt}}</td>
                  <td>{{props.item.createdBy}}</td>
                  <td>{{props.item.updatedAt}}</td>
                  <td>{{props.item.updatedBy}}</td>
                  <td>{{props.item.lastAccess}}</td>
                </template>
                <template slot="expand" slot-scope="props">
                  <v-container class="line-bottom text-left" grid-list-md style="margin-left: 0">
                    <v-layout row wrap>
                      <v-flex :key="index" v-for="(item, index) in props.item.userRoles">
                        <i class="icon material-icons">done_all</i>
                        {{item}}
                      </v-flex>
                    </v-layout>
                  </v-container>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import { urlAvatar } from '../../../helpers/avatar'
import { dateFormat } from '../../../helpers/dateHelper'
export default {
  name: 'list',
  data () {
    return {
      urlBase: urlAvatar + 'default-profile.png',
      search: '',
      expand: false,
      pagination: {
        sortBy: 'active',
        descending: true
      },

      dialog: false
    }
  },
  mounted () {
  },
  computed: {
    ...mapState({
      users: state => state.users.listaUsers,
      loading: state => state.users.loading,
      listRols: state => state.rols.list,
      listUser: state => state.users.listaUsers,
      listTeams: state => state.teams.listTeams,
      authUser: state => state.authentication.user
    }),
    formatList () {
      let filteredList = this.listUser.map(user => {
        return {
          ...user,
          userRoles: this.formatRoles(user.roles),
          rolesInfo: this.formatRoles(user.roles, true),
          lastAccess: dateFormat(user.lastAccess),
          entities: this.getUserEntities(user.roles),
          createdAt: dateFormat(user.createdAt),
          updatedAt: dateFormat(user.updatedAt),
          fullname: user.name + ' ' + user.lastname1,
          fullname2: user.lastname1 + ' ' + user.name
          // rolespermissions: this.formatPermissions(user.roles)
        }
      })

      filteredList = filteredList.filter(user => user._id != this.authUser._id)

      filteredList = this.filterArray(filteredList, this.search)

      return filteredList
    },
    headers () {
      let headers = [
        {
          text: this.$t('actions'),
          value: ''
        }, {
          text: this.$t('state'),
          value: 'active'
        }]
      if (this.isAdmin) {
        headers.push({
          text: this.$t('deleted'),
          value: 'deleted'
        })
      }
      headers = headers.concat([

        {
          text: this.$t('image'),
          value: 'avatar'
        },
        {
          text: this.$t('name'),
          value: 'name'
        },
        {
          text: this.$tc('entity'),
          value: 'entities'
        },
        {
          text: this.$tc('province'),
          value: 'province'
        },
        {
          text: this.$t('email'),
          value: 'email'
        },
        {
          text: 'Roles',
          value: 'rolesInfo'
        },
        {
          text: this.$t('createdAt'),
          value: 'createdAt'
        },
        {
          text: this.$t('createdBy'),
          value: 'createdBy'
        },
        {
          text: this.$t('updatedAt'),
          value: 'updatedAt'
        },
        {
          text: this.$t('updatedBy'),
          value: 'updatedBy'
        },
        {
          text: this.$t('lastAccess'),
          value: 'lastAccess'
        }

      ])
      return headers
    }
  },
  methods: {
    image (item) {
      return item.photo
    },
    rolsName (rolid) {
      const result = this.listRols.find(item => item._id === rolid)
      return result ? result.name : this.$t('noRole')
    },
    sendEmit (evento, elemento = null) {
      this.$emit(evento, elemento)
    },
    formatPermissions (roles) {
      let result = []
      let me = this
      if (!Array.isArray(roles) || roles.length === 0) {
        return []
      }
      roles.forEach(item => {
        let search = me.listRols.find(element => element._id = item.roleId)
        if (search) {
          result.push({
            title: item.role,
            permissions: search.permissions
          })
        }
      })
      return result
    },
    formatRoles (userRoles, info = false) {
      let roles = userRoles.map(role => {
        let result = role.role
        if (role.objects && role.objects.length) { result += ` - (${role.objects.map(object => object.name).join(', ')})` }
        return result
      })
      return info ? roles.join(', ') : roles
    },
    getUserEntities (roles) {
      let entities = []

      roles.forEach(role => {
        if (role.type == 'entities') {
          role.objects.forEach(entity => {
            if (!entities.includes(entity.name)) entities.push(entity.name)
          })
        } else if (role.type == 'teams' || role.type == 'participant') {
          role.objects.forEach(team => {
            if (!entities.includes(team.entity)) entities.push(team.entity)
          })
        }
      })

      return entities.join(', ')
    }
  }
}
</script>
<style scoped>
.cursor {
  cursor: pointer;
}

.line-bottom {
  border-bottom: 1px solid #000;
}

.text-left {
  text-align: left;
}

.success--text {
  color: green;
}

.error--text {
  color: red;
}
</style>
